'use client';
import React from 'react';
import Link from 'next/link';

export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid rgba(228,228,229,.12)', marginTop: 'auto' }}>
      <div style={{
        maxWidth: 'var(--measure)', margin: '0 auto',
        padding: 'clamp(26px,3.5vw,40px) clamp(14px,2.5vw,24px) 18px',
        display: 'flex', gap: 'clamp(24px,5vw,80px)', flexWrap: 'wrap'
      }}>
        <div style={{ flex: '1.4 1 260px', minWidth: 220 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {/* Gold checkmark badge */}
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-label="Zec Punks verified">
              <circle cx="12" cy="12" r="11" fill="#f4b728" />
              <path d="M7.5 12.5l3 3 6-6.5" stroke="#1a1003" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
            <span style={{ fontFamily: 'var(--pixel)', fontSize: 13, color: 'var(--gold)', letterSpacing: 1 }}>ZEC PUNKS</span>
          </div>
          <div style={{ marginTop: 10, fontSize: 13, color: 'rgba(228,228,229,.55)' }}>The private NFT marketplace on Zcash</div>
        </div>
        <div style={{ flex: '0 0 auto' }}>
          <div style={{ fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(228,228,229,.35)', marginBottom: 12 }}>Marketplace</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Link href="/" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Discover</Link>
            <Link href="/collection/zecbit-genesis" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Collections</Link>
            <Link href="/bridge" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Bridge</Link>
            <Link href="/activity" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Activity</Link>
          </div>
        </div>
        <div style={{ flex: '0 0 auto' }}>
          <div style={{ fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(228,228,229,.35)', marginBottom: 12 }}>Resources</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Link href="/verify" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Litepaper</Link>
            <Link href="/verify" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Whitepaper</Link>
            <Link href="/verify" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Verify guide</Link>
            <Link href="/help" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>Help</Link>
          </div>
        </div>
        <div style={{ flex: '0 0 auto' }}>
          <div style={{ fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(228,228,229,.35)', marginBottom: 12 }}>Community</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <a href="https://twitter.com/zec_punks" target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: 'rgba(228,228,229,.6)', transition: 'color .15s ease' }}>@zec_punks on X</a>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 'var(--measure)', margin: '0 auto', padding: '0 clamp(14px,2.5vw,24px) clamp(22px,3vw,30px)' }}>
        <div style={{ borderTop: '1px solid rgba(228,228,229,.06)', paddingTop: 16, fontFamily: 'var(--mono)', fontSize: 11, color: 'rgba(228,228,229,.35)' }}>
          Ownership is private by default. Prices are known only to the parties involved.
        </div>
      </div>
    </footer>
  );
}